import { PatchDetailsWebComponent } from './component/PatchDetailsWebComponent';

export { PatchDetailsWebComponent };
